'use strict';

angular.module('randomization')
    .component('recordRandomization', {
        templateUrl: 'modules/ecrd/components/randomization/content.html',
        controller: 'RecordRandomizationController',
    });
